export default __webpack_public_path__ + "static/media/series_icon.0504cbab.svg";